/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/draft.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var internal_question_input_value_pb = require('../internal/question_input_value_pb.js')

var shared_types_decimal_pb = require('../shared/types/decimal_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./draft_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.DraftServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.DraftServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CreateDraftJobRequest,
 *   !proto.worklayer.internal.v1.CreateDraftJobResponse>}
 */
const methodDescriptor_DraftService_CreateDraftJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/CreateDraftJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CreateDraftJobRequest,
  proto.worklayer.internal.v1.CreateDraftJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CreateDraftJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CreateDraftJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CreateDraftJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CreateDraftJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CreateDraftJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.createDraftJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/CreateDraftJob',
      request,
      metadata || {},
      methodDescriptor_DraftService_CreateDraftJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateDraftJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CreateDraftJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.createDraftJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/CreateDraftJob',
      request,
      metadata || {},
      methodDescriptor_DraftService_CreateDraftJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.CreateDraftJobForTeamRequest,
 *   !proto.worklayer.internal.v1.CreateDraftJobForTeamResponse>}
 */
const methodDescriptor_DraftService_CreateDraftJobForTeam = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/CreateDraftJobForTeam',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.CreateDraftJobForTeamRequest,
  proto.worklayer.internal.v1.CreateDraftJobForTeamResponse,
  /**
   * @param {!proto.worklayer.internal.v1.CreateDraftJobForTeamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.CreateDraftJobForTeamResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.CreateDraftJobForTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.CreateDraftJobForTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.CreateDraftJobForTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.createDraftJobForTeam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/CreateDraftJobForTeam',
      request,
      metadata || {},
      methodDescriptor_DraftService_CreateDraftJobForTeam,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.CreateDraftJobForTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.CreateDraftJobForTeamResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.createDraftJobForTeam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/CreateDraftJobForTeam',
      request,
      metadata || {},
      methodDescriptor_DraftService_CreateDraftJobForTeam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersRequest,
 *   !proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersResponse>}
 */
const methodDescriptor_DraftService_ReplaceDraftQuestionAnswers = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/ReplaceDraftQuestionAnswers',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersRequest,
  proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.replaceDraftQuestionAnswers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/ReplaceDraftQuestionAnswers',
      request,
      metadata || {},
      methodDescriptor_DraftService_ReplaceDraftQuestionAnswers,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ReplaceDraftQuestionAnswersResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.replaceDraftQuestionAnswers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/ReplaceDraftQuestionAnswers',
      request,
      metadata || {},
      methodDescriptor_DraftService_ReplaceDraftQuestionAnswers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.PostponeStartDateRequest,
 *   !proto.worklayer.internal.v1.PostponeStartDateResponse>}
 */
const methodDescriptor_DraftService_PostponeStartDate = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/PostponeStartDate',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.PostponeStartDateRequest,
  proto.worklayer.internal.v1.PostponeStartDateResponse,
  /**
   * @param {!proto.worklayer.internal.v1.PostponeStartDateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.PostponeStartDateResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.PostponeStartDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.PostponeStartDateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.PostponeStartDateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.postponeStartDate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/PostponeStartDate',
      request,
      metadata || {},
      methodDescriptor_DraftService_PostponeStartDate,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.PostponeStartDateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.PostponeStartDateResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.postponeStartDate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/PostponeStartDate',
      request,
      metadata || {},
      methodDescriptor_DraftService_PostponeStartDate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SubmitDraftJobRequest,
 *   !proto.worklayer.internal.v1.SubmitDraftJobResponse>}
 */
const methodDescriptor_DraftService_SubmitDraftJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/SubmitDraftJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SubmitDraftJobRequest,
  proto.worklayer.internal.v1.SubmitDraftJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SubmitDraftJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.SubmitDraftJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SubmitDraftJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.SubmitDraftJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.SubmitDraftJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.submitDraftJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/SubmitDraftJob',
      request,
      metadata || {},
      methodDescriptor_DraftService_SubmitDraftJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SubmitDraftJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.SubmitDraftJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.submitDraftJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/SubmitDraftJob',
      request,
      metadata || {},
      methodDescriptor_DraftService_SubmitDraftJob);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobSubmissionProgressRequest,
 *   !proto.worklayer.internal.v1.JobSubmissionProgress>}
 */
const methodDescriptor_DraftService_GetJobSubmissionProgress = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/GetJobSubmissionProgress',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobSubmissionProgressRequest,
  proto.worklayer.internal.v1.JobSubmissionProgress,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobSubmissionProgressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.JobSubmissionProgress.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobSubmissionProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.JobSubmissionProgress)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.JobSubmissionProgress>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.getJobSubmissionProgress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/GetJobSubmissionProgress',
      request,
      metadata || {},
      methodDescriptor_DraftService_GetJobSubmissionProgress,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobSubmissionProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.JobSubmissionProgress>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.getJobSubmissionProgress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/GetJobSubmissionProgress',
      request,
      metadata || {},
      methodDescriptor_DraftService_GetJobSubmissionProgress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RequestChampionProviderRequest,
 *   !proto.worklayer.internal.v1.RequestChampionProviderResponse>}
 */
const methodDescriptor_DraftService_RequestChampionProvider = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/RequestChampionProvider',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RequestChampionProviderRequest,
  proto.worklayer.internal.v1.RequestChampionProviderResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RequestChampionProviderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RequestChampionProviderResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RequestChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RequestChampionProviderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RequestChampionProviderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.requestChampionProvider =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/RequestChampionProvider',
      request,
      metadata || {},
      methodDescriptor_DraftService_RequestChampionProvider,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RequestChampionProviderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RequestChampionProviderResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.requestChampionProvider =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/RequestChampionProvider',
      request,
      metadata || {},
      methodDescriptor_DraftService_RequestChampionProvider);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ArchiveDraftRequest,
 *   !proto.worklayer.internal.v1.ArchiveDraftResponse>}
 */
const methodDescriptor_DraftService_Archive = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/Archive',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ArchiveDraftRequest,
  proto.worklayer.internal.v1.ArchiveDraftResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ArchiveDraftRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ArchiveDraftResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ArchiveDraftRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ArchiveDraftResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ArchiveDraftResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.archive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/Archive',
      request,
      metadata || {},
      methodDescriptor_DraftService_Archive,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ArchiveDraftRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ArchiveDraftResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.archive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/Archive',
      request,
      metadata || {},
      methodDescriptor_DraftService_Archive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetQuoteRequest,
 *   !proto.worklayer.internal.v1.GetQuoteResponse>}
 */
const methodDescriptor_DraftService_GetQuote = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/GetQuote',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetQuoteRequest,
  proto.worklayer.internal.v1.GetQuoteResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetQuoteResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.getQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/GetQuote',
      request,
      metadata || {},
      methodDescriptor_DraftService_GetQuote,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetQuoteResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.getQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/GetQuote',
      request,
      metadata || {},
      methodDescriptor_DraftService_GetQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ApplyCouponRequest,
 *   !proto.worklayer.internal.v1.ApplyCouponResponse>}
 */
const methodDescriptor_DraftService_ApplyCoupon = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/ApplyCoupon',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ApplyCouponRequest,
  proto.worklayer.internal.v1.ApplyCouponResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ApplyCouponRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ApplyCouponResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ApplyCouponRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ApplyCouponResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ApplyCouponResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.applyCoupon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/ApplyCoupon',
      request,
      metadata || {},
      methodDescriptor_DraftService_ApplyCoupon,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ApplyCouponRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ApplyCouponResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.applyCoupon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/ApplyCoupon',
      request,
      metadata || {},
      methodDescriptor_DraftService_ApplyCoupon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.RemoveCouponRequest,
 *   !proto.worklayer.internal.v1.RemoveCouponResponse>}
 */
const methodDescriptor_DraftService_RemoveCoupon = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/RemoveCoupon',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.RemoveCouponRequest,
  proto.worklayer.internal.v1.RemoveCouponResponse,
  /**
   * @param {!proto.worklayer.internal.v1.RemoveCouponRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.RemoveCouponResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.RemoveCouponRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.RemoveCouponResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.RemoveCouponResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.removeCoupon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/RemoveCoupon',
      request,
      metadata || {},
      methodDescriptor_DraftService_RemoveCoupon,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.RemoveCouponRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.RemoveCouponResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.removeCoupon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/RemoveCoupon',
      request,
      metadata || {},
      methodDescriptor_DraftService_RemoveCoupon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.UpgradeLegendRequest,
 *   !proto.worklayer.internal.v1.UpgradeLegendResponse>}
 */
const methodDescriptor_DraftService_UpgradeLegend = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/UpgradeLegend',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.UpgradeLegendRequest,
  proto.worklayer.internal.v1.UpgradeLegendResponse,
  /**
   * @param {!proto.worklayer.internal.v1.UpgradeLegendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpgradeLegendResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.UpgradeLegendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpgradeLegendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpgradeLegendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.upgradeLegend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/UpgradeLegend',
      request,
      metadata || {},
      methodDescriptor_DraftService_UpgradeLegend,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.UpgradeLegendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpgradeLegendResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.upgradeLegend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/UpgradeLegend',
      request,
      metadata || {},
      methodDescriptor_DraftService_UpgradeLegend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListPreviousProvidersRequest,
 *   !proto.worklayer.internal.v1.ListPreviousProvidersResponse>}
 */
const methodDescriptor_DraftService_ListPreviousProviders = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/ListPreviousProviders',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListPreviousProvidersRequest,
  proto.worklayer.internal.v1.ListPreviousProvidersResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListPreviousProvidersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListPreviousProvidersResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListPreviousProvidersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListPreviousProvidersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListPreviousProvidersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.listPreviousProviders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/ListPreviousProviders',
      request,
      metadata || {},
      methodDescriptor_DraftService_ListPreviousProviders,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListPreviousProvidersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListPreviousProvidersResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.listPreviousProviders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/ListPreviousProviders',
      request,
      metadata || {},
      methodDescriptor_DraftService_ListPreviousProviders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetMatchingProvidersCountRequest,
 *   !proto.worklayer.internal.v1.GetMatchingProvidersCountResponse>}
 */
const methodDescriptor_DraftService_GetMatchingProvidersCount = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.DraftService/GetMatchingProvidersCount',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetMatchingProvidersCountRequest,
  proto.worklayer.internal.v1.GetMatchingProvidersCountResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetMatchingProvidersCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetMatchingProvidersCountResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetMatchingProvidersCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetMatchingProvidersCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetMatchingProvidersCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.DraftServiceClient.prototype.getMatchingProvidersCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/GetMatchingProvidersCount',
      request,
      metadata || {},
      methodDescriptor_DraftService_GetMatchingProvidersCount,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetMatchingProvidersCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetMatchingProvidersCountResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.DraftServicePromiseClient.prototype.getMatchingProvidersCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.DraftService/GetMatchingProvidersCount',
      request,
      metadata || {},
      methodDescriptor_DraftService_GetMatchingProvidersCount);
};


module.exports = proto.worklayer.internal.v1;

